export type DataStatus =
  | "no-data"
  | "loading"
  | "ready"
  | "no-access-rights"
  | "no-client"
  | "no-client-mapping"
  | "server-error"
  | "no-portfolio-visibility"
  | "no-attribute-selected"
  | "no-kpi-selected"
  | "no-data-deals"
  | "loading-deals"
  | "no-access-rights-deals"
  | "server-error-deals"
  | "client-request-error"
  | "abacus-level-error"
  | "too-many-clients"
  | "incompatible-filters-error";

export enum DataStatusEnum {
  nodata = "no-data",
  loading = "loading",
  ready = "ready",
  noaccessrights = "no-access-rights",
  noclient = "no-client",
  noclientmapping = "no-client-mapping",
  servererror = "server-error",
  noportfoliovisibility = "no-portfolio-visibility",
  noattributeselected = "no-attribute-selected",
  nokpiselected = "no-kpi-selected",
  nodatadeals = "no-data-deals",
  loadingdeals = "loading-deals",
  noaccessrightsdeals = "no-access-rights-deals",
  servererrordeals = "server-error-deals",
  clientrequesterror = "client-request-error",
  abacuslevelerror = "abacus-level-error",
  toomanyclients = "too-many-clients",
}

export interface IGenericRequest {
  aggregationAttributes?: string;
  kpis?: string;
  topN?: number;
  page?: number;
  size?: number;
  filter?: string;
  sort?: string;
  topNSort?: string;
  date: string;
}

export interface IGenericColumns {
  id?: string;
  header?: string;
  decimal?: number;
  divisor?: number;
}

export interface IGenericCsvRequest {
  genericAggregateDto?: IGenericRequest;
  columns?: IGenericColumns[];
}

export interface IGenericRequestForRange {
  aggregationAttributes?: string;
  kpis: string;
  periodType: string;
  periodNumber: number;
  topN?: number;
  page?: number;
  size?: number;
  filter?: string;
  sort?: string;
  topNSort?: string;
  date: string;
}

export interface IAggregateRow {
  dimensionAttributeValues: { [index: string]: string };
  indicatorKpiValues: { [index: string]: number };
}

export interface IGenericAggregateResponse {
  request?: IGenericRequest;
  aggregates?: IAggregateRow[];
  noAccessRights?: boolean;
  noClientMapping?: boolean;
  serverError?: boolean;
  blobData?: Blob;
  noBudgetAccess?: boolean;
  clientRequestError?: boolean;
  statusText?: string;
}

export class GenericAggregateResponse implements IGenericAggregateResponse {
  public request?: IGenericRequest;
  public aggregates?: IAggregateRow[];
  public noAccessRights? = false;
  public noClientMapping? = false;
  public serverError? = false;
  public blobData?: Blob;
  public noBudgetAccess? = false;
  public clientRequestError? = false;
  public statusText?: string;
}

// All filters should come here.
export interface IFilter {
  fpv_bl?: string;
  fpv_sbl?: string;
  client_grpId?: number;
  client_leId?: number;
  client_subGrpId?: string;
  clientgen_id?: number;
  salesben_sales?: string;
  is_ib?: number;
}

export interface IFilterItem {
  attribute: string;
  equals: boolean;
  value: string;
}

export interface IFilterColumnsByRole {
  Headers: any[];
  Rows: any[];
}

export interface IGenericHyperlinkFilter {
  board_id: string;
  filter: IHyperlinkFilterTypes[];
}

export interface IHyperlinkFilterTypes {
  filter_id: string;
  id: string;
  name?: number;
  value: string[];
}

export interface IGenericResponse {
  data?: any[];
  noAccessRights?: boolean;
  serverError?: boolean;
}

export class GenericResponse implements IGenericResponse {
  public data?: any[];
  public noAccessRights? = false;
  public serverError? = false;
  public statusText?: string;
}

export interface IAbacusRequest {
  date: string;
  mode?: number;
  clientInput: { clientType: string; id: string };
  fpv: { level?: string; labels: string[] };
  clientTypo: string[];
  geographicalArea: string[];
}

interface IKeyValuePair<T> {
  key: string;
  value: T;
}

export interface IAbacusResponse {
  dimension: IKeyValuePair<string>;
  data: Array<IKeyValuePair<string>>;
  measureInfo?: Array<IKeyValuePair<string>>;
  noAccessRights?: boolean;
  noClientMapping?: boolean;
  serverError?: boolean;
  statusText?: string;
}

export interface AttributesValidation {
  valid: boolean;
  attribute: string | undefined;
}
